<template>
  <div>
    <div>
      <el-steps :active="active" process-status="wait" finish-status="finish">
        <el-step title="上传应用"></el-step>
        <el-step title="上传中"></el-step>
        <el-step title="上传成功，解析应用"></el-step>
        <el-step title="发布应用"></el-step>
      </el-steps>
    </div>
    <div class="upload-div">
      <!-- 上传 -->
      <div v-show="uploadView.showUploader">
        <uploader
          ref="uploader"
          singleFile="true"
          :options="options"
          :autoStart="true"
          @file-added="onFileAdded"
          @file-success="onFileSuccess"
          @file-progress="onFileProgress"
          @file-complete="onFileComplete"
          @file-error="onFileError"
          @complete="onComplete"
          class="uploader-app">
          <uploader-unsupport></uploader-unsupport>
          <uploader-drop>
              <uploader-btn>点击此区域上传，或者拖拽文件到此区域</uploader-btn>
          </uploader-drop>
        </uploader>
      </div>
      <div v-show="uploadView.showUploaderProgress" class="div-cancel">
        <div class="div-cancel-label">
          <label class="cancel-label">文件正在上传中，请不要关闭浏览器</label>
        </div>
        <el-progress :stroke-width="28"  :percentage="percentage" :color="customColors"
                     :format="format"></el-progress>
        <div class="div-cancel-btn">
          <el-button class="el-button-cancel" :type="uploadView.showUploaderType" :loading="uploadView.showUploaderSuccess"
                     @click.native="onCancelUpload()">{{uploadView.showUploadState}}</el-button>
        </div>
      </div>

      <el-card v-show="uploadView.showUploaderResult" class="box-card div-public ">
        <div slot="header" class="clearfix">
          <span>{{packageInfo.name}}</span>
          <el-button style="float: right; padding: 3px 0" type="text"  @click.native="onCancelPublic()">取消发布</el-button>
        </div>
        <div>
          <div style="width: 100%">
            <el-row >
              <el-col :span="4">
                <div>
                 <el-image class="div-public-image" :src="this.$global.baseURL.concat(packageInfo.icon)"/>
                </div>
              </el-col>
              <el-col :span="20">
                <el-row >
                  <el-col :span="8" style="height: 100%">
                    <div>
                      <label class="div-public-label">PackageName:<span class="div-public-label-span">{{packageInfo.packageName}}</span></label>
                    </div>
                    <div class="div-public-label-top">
                      <label class="div-public-label">大小:<span class="div-public-label-span">{{packageInfo.size}} MB</span></label>
                     </div>
                    <div class="div-public-label-top">
                      <label class="div-public-label">创建时间:<span class="div-public-label-span">{{packageInfo.buildTime}}</span></label>
                    </div>
                    <div class="div-public-label-top">
                      <label class="div-public-label">发布说明:</label>
                      <el-input   type="textarea"   class="div-public-label-top"
                                  :rows="3"
                                  v-model="packageInfo.content" style="height: 100px"/>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div>
                      <label class="div-public-label">VersionCode:<span class="div-public-label-span">{{packageInfo.versionCode}}</span></label>
                    </div>
                    <div class="div-public-label-top">
                      <label class="div-public-label">MinSdkVersion:<span class="div-public-label-span">{{packageInfo.minSdkVersion}}</span></label>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div>
                      <label class="div-public-label">VersionName:<span class="div-public-label-span">{{packageInfo.versionName}}</span></label>
                    </div>
                    <div class="div-public-label-top">
                      <label class="div-public-label">TargetSdkVersion:<span class="div-public-label-span">{{packageInfo.targetSdkVersion}}</span></label>
                    </div>
                    <el-button class="div-public-submit-btn" type="success" :loading="uploadView.showUploaderPublic"
                               @click.native="onSubmitPublic">{{uploadView.showUploadState}}</el-button>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>

        </div>

      </el-card>

    </div>
    <div >
      <el-upload
        drag
        v-show="false"
        :http-request="handleFileUpload"
        action=""
        multiple>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
      </el-upload>
    </div>
  </div>

</template>

<script>
import SparkMD5 from 'spark-md5'
const stateInit = 0
const stateMD5 = 1
const stateProgress = 2
const stateParse = 3
const stateResult = 4
const statePublicing = 5
export default {
  name: 'MainPublicAPP',
  components: {
  },
  mounted () {
    this.$nextTick(() => {
      window.uploader = this.$refs.uploader.uploader
    })
    this.showUploaderView(stateInit)
    // this.onParse('55\\LG_GPS.apk')
  },
  data () {
    return {
      options: {
        // 目标上传 URL
        target: this.$global.baseURL.concat('main/apkUpload'),
        // 上传文件时文件的参数名，默认file
        fileParameterName: 'file',
        // 最大自动失败重试上传次数
        maxChunkRetries: 3,
        // 5*1024*1024分块
        simultaneousUploads: 1,
        chunkSize: 512 * 1024,
        // 是否开启服务器分片校验
        testChunks: false,
        progressCallbacksInterval: 100,
        headers: {
          // 在header中添加的验证，请根据实际业务来
          // Authorization: "Bearer " + Ticket.get().access_token
        },
        query: {
          // form data里的参数 根据实际需要
        }
      },
      attrs: {
        // 接受的文件类型，形如['.png', '.jpg', '.jpeg', '.gif', '.bmp'...] 这里我封装了一下
        accept: ['apk']
      },
      time: null,
      active: 1,
      percentage: 0,
      customColor: '#409eff',
      customColors: [
        {color: '#f56c6c', percentage: 20},
        {color: '#e6a23c', percentage: 40},
        {color: '#5cb87a', percentage: 60},
        {color: '#1989fa', percentage: 80},
        {color: '#6f7ad3', percentage: 100}
      ],
      uploadView: {
        showUploader: false,
        showUploaderProgress: true,
        showUploaderSuccess: false,
        showUploaderResult: false,
        showUploaderPublic: false,
        showUploaderType: 'danger',
        showUploadState: '取消'
      },
      uniqueIdentifier: '',
      apkPath: '',
      packageInfo: {
        name: 'undefined',
        packageName: 'undefined',
        buildTime: '1979-01-01',
        label: '',
        content: '',
        size: 0,
        icon: '../static/ic_launcher_round.png',
        versionName: '0.0',
        versionCode: 0,
        minSdkVersion: '1',
        targetSdkVersion: '29'
      }
    }
  },
  activated () {
    if (!this.showUploader) {
      this.onCancelUpload()
      this.showUploaderView(stateInit)
    }
  },
  deactivated () {
  },
  methods: {
    showUploaderView (type) {
      this.active = type + 1
      switch (type) {
        case stateInit:
          this.uploadView.showUploader = true
          this.uploadView.showUploaderProgress = false
          this.uploadView.showUploaderSuccess = false
          this.uploadView.showUploaderResult = false
          this.uploadView.showUploaderPublic = false
          this.packageInfo.name = ''
          this.packageInfo.packageName = ''
          this.packageInfo.versionName = ''
          this.packageInfo.versionCode = 0
          this.packageInfo.size = 0
          this.packageInfo.icon = ''
          this.packageInfo.minSdkVersion = ''
          this.packageInfo.targetSdkVersion = ''
          this.packageInfo.buildTime = ''
          this.packageInfo.content = ''
          break
        case stateMD5:
          this.uploadView.showUploader = false
          this.uploadView.showUploadState = '正在计算MD5值'
          this.uploadView.showUploaderType = 'info'
          this.uploadView.showUploaderProgress = true
          this.uploadView.showUploaderSuccess = true
          this.uploadView.showUploaderResult = false
          this.uploadView.showUploaderPublic = false
          break
        case stateProgress:
          this.uploadView.showUploader = false
          this.uploadView.showUploadState = '取消'
          this.uploadView.showUploaderType = 'danger'
          this.uploadView.showUploaderProgress = true
          this.uploadView.showUploaderSuccess = false
          this.uploadView.showUploaderResult = false
          this.uploadView.showUploaderPublic = false
          break
        case stateParse:
          this.uploadView.showUploader = false
          this.uploadView.showUploaderProgress = true
          this.uploadView.showUploaderSuccess = true
          this.uploadView.showUploaderResult = false
          this.uploadView.showUploadState = '正在解析....'
          this.uploadView.showUploaderType = 'info'
          this.uploadView.showUploaderPublic = false
          break
        case stateResult:
          this.uploadView.showUploadState = '发布'
          this.uploadView.showUploaderProgress = false
          this.uploadView.showUploader = false
          this.uploadView.showUploaderSuccess = false
          this.uploadView.showUploaderResult = true
          this.uploadView.showUploaderPublic = false
          break
        case statePublicing:
          this.uploadView.showUploaderProgress = false
          this.uploadView.showUploader = false
          this.uploadView.showUploaderSuccess = false
          this.uploadView.showUploaderResult = true
          this.uploadView.showUploadState = '发布中....'
          this.uploadView.showUploaderPublic = true
          break
      }
    },
    onFileComplete (rootFile) {
      console.log(`onFileComplete: 用时：${new Date().getTime() - this.time} ms`)
    },
    onComplete () {
      console.log('onComplete')
    },
    onFileSuccess (rootFile, file, response, chunk) {
      console.log('response:'.concat(response))
      let data = JSON.parse(response)
      if (data.code === 200) {
        this.percentage = 100
        this.apkPath = data.data
        this.showUploaderView(stateParse)
        this.onParse(data.data)
      } else {
        this.onParseError(data.data)
      }
    },
    onFileError (rootFile, file, response, chunk) {
      this.showUploaderView(stateInit)
      this.percentage = 0
      this.errorInfo = true
      this.errInfo = '上传错误'
      this.$message.error('上传错误，请检查当前网络或者远程服务器状态')
    },
    onParse (path) {
      if (path.endsWith('.apk')) {
        this.$axios({
          url: this.$global.baseURL.concat('main/apkParse'),
          method: 'post',
          data: {apkPath: path}
        }).then(response => {
          if (response.data.code === 200) {
            // 重新刷新数据
            let packageInfoData = response.data.data
            this.packageInfo.name = packageInfoData.name
            this.packageInfo.packageName = packageInfoData.packageName
            this.packageInfo.versionName = packageInfoData.versionName
            this.packageInfo.versionCode = packageInfoData.versionCode
            this.packageInfo.size = packageInfoData.size
            this.packageInfo.icon = packageInfoData.icon.replaceAll('\\', '/')
            this.packageInfo.minSdkVersion = packageInfoData.minSdkVersion
            this.packageInfo.targetSdkVersion = packageInfoData.targetSdkVersion
            this.packageInfo.buildTime = packageInfoData.buildTime
            this.packageInfo.content = packageInfoData.content
            this.showUploaderView(stateResult)
          } else {
            this.onParseError(response.data.data)
          }
        })
      } else {
        this.$axios({
          url: this.$global.baseURL.concat('main/fileParse'),
          method: 'post',
          data: {filePath: path}
        }).then(response => {
          if (response.data.code === 200) {
            // 重新刷新数据
            let packageInfoData = response.data.data
            this.packageInfo.name = packageInfoData.name
            this.packageInfo.size = packageInfoData.size
            this.packageInfo.buildTime = packageInfoData.buildTime
            this.showUploaderView(stateResult)
          } else {
            this.onParseError(response.data.data)
          }
        })
      }
    },
    onParseError (error) {
      this.showUploaderView(stateInit)
      this.percentage = 0
      this.errorInfo = true
      this.$message({
        duration: 0,
        showClose: true,
        message: '解析失败，请重新上传，错误详情：' + error,
        type: 'error'
      })
    },
    // 文件进度的回调
    onFileProgress (rootFile, file, chunk) {
      // console.log(`上传中`.concat(window.uploader.progress()))
      this.percentage = window.uploader.progress() * 100
    },
    onFileAdded (file) {
      this.percentage = 0
      this.computeMD5(file)
    },
    uploadFileToServer (file, chunkNumber) {
      // , chunkNumber, chunkTotal, chunkSize
      // 文件名
      const { name } = file
      // 文件大小
      const { size } = file
      // 分片大小
      let chunkSize = this.options.chunkSize
      // 文件加密
      // const hash: string = await getMD5(file);
      // 分片总数
      const chunkTotal = Math.ceil(size / chunkSize)
      // 文件开始结束的位置
      const start = (chunkNumber - 1) * chunkSize
      let end = start + chunkSize
      if (end > size) {
        end = size
      }
      // 开始切割 size:450646108
      console.log('chunkNumber:' + chunkNumber)
      const packet = file.slice(start, end)
      const form = new FormData()
      // 这里的data是文件
      form.append('file', packet)
      form.append('chunkNumber', chunkNumber)
      form.append('totalChunks', chunkTotal)
      form.append('chunkSize', chunkSize)
      form.append('filename', name)
      form.append('identifier', file.uniqueIdentifier)
      this.$axios({
        url: this.$global.baseURL.concat('main/apkUpload'),
        method: 'post',
        data: form
      }).then(response => {
        // 重新刷新数据
        console.log('response:', response)
        let data = response.data
        if (data.code === 200) {
          if (chunkNumber >= chunkTotal) {
            this.percentage = 100
            this.apkPath = data.data
            this.showUploaderView(stateParse)
            this.onParse(data.data)
          } else {
            this.percentage = parseInt(end * 100 / size)
            this.uploadFileToServer(file, chunkNumber + 1)
          }
        } else {
          this.onParseError(data.data)
        }
      })
    },
    /**
     * @description: 选择上传文件
     * @param file el-upload 返回的参数
     */
    handleFileUpload (args) {
      this.showUploaderView(stateMD5)
      let fileReader = new FileReader()
      this.time = new Date().getTime()
      let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
      let currentChunk = 0
      let file = args.file
      const chunkSize = this.options.chunkSize
      let chunks = Math.ceil(file.size / chunkSize)
      let spark = new SparkMD5.ArrayBuffer()
      // file.pause()
      loadNext()
      let vm = this
      fileReader.onload = function (e) {
        spark.append(e.target.result)
        if (currentChunk < chunks) {
          currentChunk++
          loadNext()
        } else {
          let md5 = spark.end()
          // loading.close()
          vm.showUploaderView(stateProgress)
          file.uniqueIdentifier = md5// 把md5值作为文件的识别码
          this.uniqueIdentifier = md5// file.md5
          vm.uploadFileToServer(file, 1)
          // vm.computeMD5Success(md5, file)
          console.log(`MD5计算完毕：${file.name} \nMD5：${md5} \n分片：${chunks} 大小:${file.size} 用时：${new Date().getTime() - vm.time} ms`)
        }
      }
      fileReader.onerror = function () {
        console.log(`文件${file.name}读取出错，请检查该文件`)
        vm.error(`文件${file.name}读取出错，请检查该文件`)
        // loading.close()
        vm.showUploaderView(stateInit)
        // file.cancel()
      }
      function loadNext () {
        let start = currentChunk * chunkSize
        let end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize
        fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
      }
    },
    format (percentage) {
      percentage = parseInt(percentage)
      return percentage < 10 ? `0${percentage} %` : `${percentage} %`
    },
    computeMD5 (file) {
      this.showUploaderView(stateMD5)
      let fileReader = new FileReader()
      this.time = new Date().getTime()
      let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
      let currentChunk = 0
      const chunkSize = this.options.chunkSize
      let chunks = Math.ceil(file.size / chunkSize)
      let spark = new SparkMD5.ArrayBuffer()
      file.pause()
      loadNext()
      let vm = this
      fileReader.onload = function (e) {
        spark.append(e.target.result)
        if (currentChunk < chunks) {
          currentChunk++
          loadNext()
        } else {
          let md5 = spark.end()
          console.log(`MD5计算完毕：${file.name} \nMD5：${md5} \n分片：${chunks} 大小:${file.size} 用时：${new Date().getTime() - vm.time} ms`)
          // loading.close()
          vm.showUploaderView(stateProgress)
          vm.computeMD5Success(md5, file)
        }
      }
      fileReader.onerror = function () {
        this.error(`文件${file.name}读取出错，请检查该文件`)
        // loading.close()
        this.showUploaderView(stateInit)
        file.cancel()
      }
      function loadNext () {
        let start = currentChunk * chunkSize
        let end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize
        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end))
      }
    },
    computeMD5Success (md5, file) {
      this.time = new Date().getTime()
      file.uniqueIdentifier = md5// 把md5值作为文件的识别码
      this.uniqueIdentifier = file.uniqueIdentifier
      file.resume() // 开始上传
    },
    onCancelUpload () {
      // console.log('onCancelUpload')
      this.$refs.uploader.uploader.cancel()
      // window.uploader.cancel()
      this.onCancelPublic()
    },
    onCancelPublic () {
      this.showUploaderView(stateInit)
      this.onDeleteDir()
    },
    onDeleteDir () {
      if (this.uniqueIdentifier !== '') {
        this.$axios({
          url: this.$global.baseURL.concat('main/apkDeleteDir'),
          method: 'post',
          data: {identifier: this.uniqueIdentifier}
        }).then(successResponse => {})
        this.uniqueIdentifier = ''
      }
    },
    onSubmitPublic () {
      console.log('onSubmitPublic'.concat(this.uniqueIdentifier))
      this.showUploaderView(statePublicing)
      if (this.uniqueIdentifier !== '') {
        this.$axios({
          url: this.$global.baseURL.concat('main/apkPublic'),
          method: 'post',
          data: {
            name: this.packageInfo.name,
            packageName: this.packageInfo.packageName,
            versionName: this.packageInfo.versionName,
            versionCode: this.packageInfo.versionCode,
            size: this.packageInfo.size,
            icon: this.packageInfo.icon,
            minSdkVersion: this.packageInfo.minSdkVersion,
            targetSdkVersion: this.packageInfo.targetSdkVersion,
            buildTime: this.packageInfo.buildTime,
            content: this.packageInfo.content,
            apkPath: this.apkPath}
        }).then(successResponse => {
          if (successResponse.data.code === 200) {
            this.onCancelPublic()
            this.$message.success('发布成功！')
            let id = successResponse.data.data
            if (id === 0) {
              this.bus.$emit('busChangeHead', '4')
              this.$nextTick(function () {
                this.bus.$emit('busChangeFile')
              })
            } else {
              this.bus.$emit('busChangeHead', '3')
              this.$nextTick(function () {
                this.bus.$emit('busChangeAppCenter', id)
              })
            }
          } else {
            this.onCancelPublic()
            this.percentage = 0
            this.errorInfo = true
            this.errInfo = '发布失败-' + successResponse.data.data
            this.$message.error('发布失败，请先检查本地网络或服务器的状态后重新上传')
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.el-steps{
  margin-top: 4%;
  margin-left:  8%;
  margin-right: 26%;
}
.upload-div{
  margin-top: 2%;
  height: 300px;
  width: 84%;
  margin-left: 8%;
  padding: 0;
}
.uploader-drop{
  cursor: pointer;
  border-width: 0;
  padding: 0;
  margin: 0;
}
.uploader-dragover {
  background: #9EEA6A;
}
.uploader-app{
  border:1px dashed  black
}
.uploader-btn{
  height: 300px;
  width: 100%;
  padding: 0;
  font-size: 18px;
  line-height:260px;
  text-align: center;
  color: black;
  border: 0;
}
.uploader-btn:hover{
  background: rgba(255,255,255,0);
  border: 0;
}
.el-progress{
  margin-left: 10%;
  margin-top: 3%;
  margin-right: 10%;
}
.div-cancel-label{
  text-align: center;
  padding-top: 70px;
}
.cancel-label{
  font-size: 19px;
}
.div-cancel-btn{
  text-align: center;
}
.div-cancel{
  width: 100%;
  height: 100%;
  background: #F5F5F5;
  border:1px dashed  black
}
.div-public{
  width: 100%;
  height: 100%;
}
.el-button-cancel{
  width: 20%;
  margin-top: 2%;
  font-size: 17px;
}
.div-public-btn{
  height: 100%;
  text-align: right;
}

.div-public-submit-btn{
  width: 200px;
  margin-top: 30%;
  margin-left: 30%;
}
.div-public-label{
  font-size: medium;
  color: gray;
}
.div-public-label-top{
  margin-top: 3%;
}
.div-public-label-span{
  font-size: large;
  color: black
}
.div-public-image{
  width: 150px;
  height: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/MainPublicAPP.vue